import { useQuery } from '@tanstack/react-query'
import { AccountService } from '@/services/account.service'
import { DevicesService } from '@/services/devices.service'
import { GroupService } from '@/services/group.service'
import { PaymentsService } from '@/services/payments.service'

/** Единые ключи кэша react-query — мутации инвалидируют по ним. */
export const queryKeys = {
	subscriptions: ['subscriptions'] as const,
	account: ['account'] as const,
	groups: ['groups'] as const,
	referralsStats: ['referrals-stats'] as const,
	devices: ['devices'] as const,
}

/**
 * Подписки пользователя (GET /payments/subscriptions). Используется сайдбаром,
 * страницей подписок, сменой тарифа и модалкой истории — все они делят один
 * закэшированный результат вместо отдельных запросов на каждой странице.
 */
export function useSubscriptions(options?: { enabled?: boolean }) {
	return useQuery({
		queryKey: queryKeys.subscriptions,
		queryFn: () => PaymentsService.getPayments(),
		enabled: options?.enabled ?? true,
	})
}

/** Данные аккаунта (GET /account). Делятся между /profile и /profile/edit. */
export function useAccount(options?: { enabled?: boolean }) {
	return useQuery({
		queryKey: queryKeys.account,
		queryFn: () => AccountService.getAccountInfo(),
		enabled: options?.enabled ?? true,
	})
}

/** Статистика по рефералам текущего пользователя (GET /account/referrals/stats). */
export function useReferralsStats(options?: { enabled?: boolean }) {
	return useQuery({
		queryKey: queryKeys.referralsStats,
		queryFn: () => AccountService.getReferralsStats(),
		enabled: options?.enabled ?? true,
	})
}

/**
 * Каталог тарифов (GET /groups) — полный список продуктов в каждой группе.
 * Нужен для смены тарифа: в самой подписке встроен только текущий продукт,
 * а альтернативы берутся отсюда.
 */
export function useGroups(options?: { enabled?: boolean }) {
	return useQuery({
		queryKey: queryKeys.groups,
		queryFn: () => GroupService.getGroups(),
		enabled: options?.enabled ?? true,
	})
}

/** Устройства, привязанные к подписке (GET /devices). */
export function useDevices(options?: { enabled?: boolean }) {
	return useQuery({
		queryKey: queryKeys.devices,
		queryFn: () => DevicesService.getDevices(),
		enabled: options?.enabled ?? true,
	})
}
